import { catalogFontFamilies, FONT_FAMILY, fontFamilyParam, fontsHref } from "@stackje/site-builder/type-pairings";

/** Families offered as suggestions while the owner types; any Google Fonts family works. */
export const FONT_SUGGESTIONS = catalogFontFamilies();

/** Whether a name can be a Google Fonts family at all, before asking Google. */
export function isFontName(family: string): boolean {
  return FONT_FAMILY.test(family.trim());
}

/**
 * Whether Google Fonts has this family. Google answers a real family with a stylesheet (and CORS
 * headers) and an unknown one with a 400 (without them), so any failure means "not found".
 */
export async function googleFontExists(family: string, fetcher: typeof fetch = fetch): Promise<boolean> {
  try {
    const response = await fetcher(fontsHref([fontFamilyParam(family.trim())]));
    return response.ok;
  } catch {
    return false;
  }
}

/** A stylesheet that loads these families, to preview them in the Brand tab. */
export function fontPreviewHref(families: readonly string[]): string {
  return fontsHref(families.map((family) => fontFamilyParam(family.trim())));
}

/** A family for CSS, quoted, with a neutral fallback while it loads. */
export function fontFamilyCss(family: string): string {
  return `'${family.trim()}', system-ui, sans-serif`;
}
